import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function HomeCategories() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            热门游戏分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            PG国际008平台汇聚多种游戏类型，总有一款适合你
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100/80 text-primary-600 mx-auto mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500">{cat.games.length} 款游戏</p>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/category/slots"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
          >
            查看全部游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}